import { useAuthContext } from "../../../context/authContext";
import { PiPackage, PiTimer, PiCheck } from "react-icons/pi";
import { useGetKeyStats } from "../../../api/hooks/index";

export function Banner() {
  const { state: authState } = useAuthContext();
  const { data: keyStatsData, isLoading, isError } = useGetKeyStats();

  const keyStats = keyStatsData
    ? [
        {
          title: "Shipments Created",
          value: keyStatsData.shipmentsSent,
          icon: PiPackage,
        },
        {
          title: "Upcoming Deliveries",
          value: keyStatsData.upcomingDeliveries,
          icon: PiTimer,
        },
        {
          title: "Last Delivered",
          value: keyStatsData.lastDelivered
            ? new Date(keyStatsData.lastDelivered).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })
            : "-",
          icon: PiCheck,
        },
      ]
    : [];

  return (
    <div className="bg-gradient-to-br from-[#0052FF] to-[#0099FF] rounded-xl p-6 sm:p-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 shadow-md">
      {/* Welcome Message */}
      <div>
        <p className="text-white/80 font-medium text-sm">Welcome,</p>
        <h2 className="text-2xl font-bold text-white mt-1">
          {authState.me?.name || "Guest"}
        </h2>
        <p className="text-white/70 mt-1">Ready to manage your shipments?</p>
      </div>

      {/* Key Stats */}
      <div className="flex flex-wrap gap-4">
        {isLoading ? (
          [1, 2, 3].map((i) => (
            <div
              key={i}
              className="flex items-center gap-3 bg-white/20 backdrop-blur-md border border-white/30 px-4 py-3 rounded-lg shadow-sm animate-pulse"
            >
              <div className="w-10 h-10 bg-white/30 rounded-full"></div>
              <div className="flex flex-col gap-1">
                <div className="h-3 w-20 bg-white/30 rounded"></div>
                <div className="h-4 w-12 bg-white/40 rounded"></div>
              </div>
            </div>
          ))
        ) : isError ? (
          <p className="text-red-200">Failed to load stats</p>
        ) : (
          keyStats.map((stat, i) => {
            const Icon = stat.icon;
            return (
              <div
                key={i}
                className="flex items-center gap-3 bg-white/20 backdrop-blur-md border border-white/30 px-4 py-3 rounded-lg shadow-sm"
              >
                <div className="flex items-center justify-center w-10 h-10 bg-white/90 rounded-full text-[#0052FF] text-xl">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="flex flex-col">
                  <p className="text-white text-sm">{stat.title}</p>
                  <p className="text-white font-semibold">{stat.value}</p>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
